// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"895698aa","455":"c212d86b","977":"c340bd32"}[chunkId] + ".chunk.js";
};